export default "__VITE_ASSET__841967f0__"